import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/play_store_badge.webp")